<template>
  <v-navigation-drawer
    :value="isSidebarSendActive"
    temporary
    touchless
    :right="!$vuetify.rtl"
    width="350"
    app
    @input="val => $emit('update:is-sidebar-send-active', val)"
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center">
        <h4 class="font-weight-semibold text-base">
          {{ $t('lbl.gestionCode') }}
        </h4>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click="$emit('update:is-sidebar-send-active', false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-form>
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="subject"
                outlined
                :label="$t('lbl.subject')"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <SidebarCodesSendEmail
                v-for="(email, ind) in emailsCodes"
                :key="ind"
                :pos="ind"
                :email="email"
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <!--<v-textarea
                v-model="clientCarShop.message"
                outlined
                :label="$t('lbl.message')"
                rows="11"
                hide-details="auto"
                class="mb-6"
              >
              </v-textarea>-->
              <tiptap-vuetify
                v-model="messageSend"
                :extensions="extensions"
                :placeholder="`${$t('lbl.message')}...`"
              />
            </v-col>
          </v-row>

          <!--<v-chip
            color="primary"
            small
            label
            class="v-chip-light-bg primary--text mb-6"
          >
            {{ $t('lbl.adjuntCotization') }}
          </v-chip>-->

          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-btn
                color="error"
                block
                @click="$emit('update:is-sidebar-send-active', false)"
              >
                {{ $t('btn.cancele') }}
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-btn
                color="primary"
                outlined
                block
                :disabled="!subject || !messageSend || emailsCodes.length === 0"
                :loading="loading"
                @click="sendEmail"
              >
                {{ $t('btn.send') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { mdiClose } from '@mdi/js'
import {
  TiptapVuetify,
  Bold,
  Italic,

  // BulletList,
  // OrderedList,
  // ListItem,
  HardBreak /* Paragraph, Strike, Heading, Underline, Code, BulletList, OrderedList, ListItem, Link, Blockquote, HorizontalRule, History, */,
} from 'tiptap-vuetify'

import SidebarCodesSendEmail from './SidebarCodesSendEmail.vue'

export default {
  components: {
    TiptapVuetify,
    SidebarCodesSendEmail,
  },
  model: {
    prop: 'isSidebarSendActive',
    event: 'update:is-sidebar-send-active',
  },
  props: {
    isSidebarSendActive: {
      type: Boolean,
      required: true,
    },
    nameSource: {
      type: String,
      required: true,
    },
    source: {
      type: String,
      required: true,
    },
    proveedor: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      extensions: [
        // BulletList,
        // OrderedList,
        // ListItem,
        Italic,
        Bold,
        HardBreak,
      ],
      icons: {
        mdiClose,
      },
      messageSend: '',
    }
  },
  computed: {
    ...mapState({
      loadingBtn: state => state.app.loadingBtn,
      emailsCodes: state => state.app.emailsCodes,
    }),
    subject: {
      get() {
        const msg = `Actualización de los códigos de hoteles para el Channel Manager ${this.nameSource}`

        return msg
      },
    },
    message: {
      get() {
        const msg = `<p>Atte: ${this.proveedor.name_comercial}, a continuación adjuntamos el listado actualizado con los códigos de hoteles integrados al Channel Manager ${this.nameSource}. Tenga en cuenta que algunas propiedades pudieron haber sido modificadas.
          <br /><br />
          Aprovechamos la oportunidad para validar que el listado incluya todos los hoteles pactados en nuestro contrato.
        <br /><br />
        Agradecemos su tiempo y gestión.
      <br /><br />
      Gracias,
      <br />
      ${this.user.name} ${this.user.apellidos}
    </p>
`

        return msg
      },
    },
  },
  created() {
    this.messageSend = this.message
  },

  methods: {
    ...mapMutations(['setCheckAllCobros', 'updateItemCheckCobros']),
    sendEmail() {
      const json = {
        subject: this.subject,
        message: this.messageSend,
        emails: this.emailsCodes,
        source: this.source,
        contrate_id: sessionStorage.getItem('hotels-contrate-id'),
      }

      this.loading = true
      this.axios
        .post('contrate_hotels/send-codes-emails', json, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          // eslint-disable-next-line no-empty
          if (res.data.success === true) {
            this.$emit('update:is-sidebar-send-active', false)
            this.$toast.success(this.$t('msg.sendEmails'))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
